import { render, staticRenderFns } from "./TrendChartGroup.vue?vue&type=template&id=61fca364&scoped=true&"
import script from "./TrendChartGroup.vue?vue&type=script&lang=js&"
export * from "./TrendChartGroup.vue?vue&type=script&lang=js&"
import style0 from "./TrendChartGroup.vue?vue&type=style&index=0&id=61fca364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fca364",
  null
  
)

export default component.exports